module.exports = __webpack_public_path__ + "static/media/step1-wd3.f105c319.svg";